import React, { Component } from 'react';
import _ from 'lodash';
import { MenuItem, Dropdown } from 'react-bootstrap';
import AccountDetailsBL from './AccountDetailsBL';

class AccountDropDownComponent extends Component {
  displayAccountDropDown() {
    const dropDown = [];
    _.map(this.props.accountList, (account, index) => {
      const accountNumber = AccountDetailsBL.getAccountDisplayNumber(account);
      const balances = AccountDetailsBL.getBalances(account);
      const accountDropDown = (
        <MenuItem
          key={account.id}
          eventKey={index.toString()}
          onSelect={this.props.onAccountSelect.bind(this, account)}
        >
          <div>
            {account.metadata.account_name && (
              <span>{account.metadata.account_name}</span>
            )}
            <div>{account.displayName}</div>
            <div className="type--jura">
              <span className="u-visually-hidden off-screen">
                Account Sort Code and Account Number{' '}
              </span>
              {accountNumber}
            </div>
            <div>
              <span className="u-visually-hidden off-screen"> Balance </span>
              {balances.currentBalance}
            </div>
          </div>
        </MenuItem>
      );
      dropDown.push(accountDropDown);
    });
    return dropDown;
  }

  render() {
    let singleAccountOrDropDown;
    const { accountList, allowAccountChange, selectedAccount } = this.props;
    if (accountList.length > 1 && allowAccountChange) {
      singleAccountOrDropDown = (
        <div className="btn-toolbar">
          <Dropdown id="account-list" className="custom-dropdown">
            <Dropdown.Toggle noCaret>
              {this.props.selectedAccount.metadata.account_name && (
                <span className="account-holder">
                  {this.props.selectedAccount.metadata.account_name}
                </span>
              )}
              <span
                id="accountName"
                className="btn--title type--mull"
                aria-labelledby="accountName accountDetails"
              >
                {this.props.selectedAccount.displayName}
              </span>
              <span className={'symbol '}>
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
                </svg>
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu>{this.displayAccountDropDown()}</Dropdown.Menu>
          </Dropdown>
        </div>
      );
    } else {
      singleAccountOrDropDown = (
        <div>
          <div>{selectedAccount.displayName}</div>
        </div>
      );
    }
    return (
      <div data-type="account" className="type--mull bold">
        {singleAccountOrDropDown}
      </div>
    );
  }
}

export default AccountDropDownComponent;
